/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { agentManager } from '@/api/ajax';

export default {
  index: {
    width: '100px',
    label: '序号',
    type: 'index'
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  months: {
    showToolTip: false,
    label: '历史参与月度',
    prop: 'months',
    render(h, ctx, row) {
      const taskDts = row.taskDts.split(',').sort((a, b) => {
        return new Date(a) - new Date(b);
      });
      const vm = ctx.parent;
      const jump = month => {
        return () => {
          let query = {
            projectId: row.id,
            fullName: vm.defaultQuery.fullName,
            phone: vm.defaultQuery.phone,
            dateRangeStart: month,
            dateRangeEnd: month,
            isComplete: 2
          };
          vm.$toRecord(query);
        };
      };
      return (
        <div style="text-align:left">
          {taskDts.map(item => {
            return (
              <el-button
                type="text"
                style="margin: 0 10px"
                onClick={jump(item)}
              >
                {item}
              </el-button>
            );
          })}
        </div>
      );
    }
  },
  status: {
    width: '180px',
    label: '启用状态',
    prop: 'status',
    render(h, ctx, row) {
      let switchChange = async () => {
        const status = row.userPorjectStatus === 1 ? 2 : 1;
        await agentManager.operateUserProjectStatus({
          id: row.id,
          status
        });
        row.userPorjectStatus = status;
      };
      // userStatus 3 账号注销
      return row.userPorjectStatus == 3 ? (
        // <span>已注销</span>
        <el-switch
          disabled
          value={2}
          active-value={1}
          inactive-value={2}
          active-color="#13ce66"
          inactive-color="#ff4949"
        />
      ) : (
        <el-switch
          value={row.userPorjectStatus}
          active-value={1}
          inactive-value={2}
          active-color="#13ce66"
          inactive-color="#ff4949"
          onchange={switchChange}
        />
      );
    }
  }
};
